import { Snackbar, Stack } from '@mui/material';
import { useToast } from '../../hooks/useToast';
import { Toast } from './toast';

export function Toaster() {
  const { toasts } = useToast();
  const firstToast = toasts[0];

  return (
    <Snackbar
      open={!!firstToast}
      autoHideDuration={null}
      transitionDuration={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
    >
      <Stack flexDirection="column-reverse" gap={1}>
        {toasts.map((toast) => (
          <Toast key={toast.id} toast={toast} />
        ))}
      </Stack>
    </Snackbar>
  );
}
